import dayjs, { Dayjs } from 'dayjs';

export const notSameYear = (date: Dayjs, startDate: Date | null, endDate: Date | null, position: 'start' | 'end') =>
  startDate && position === 'end' ? date.isBefore(startDate) || date.isAfter(dayjs(startDate).endOf('year')) : false;

export const notWithinYearRange = (
  date: Dayjs,
  startDate: Date | null,
  endDate: Date | null,
  position: 'start' | 'end',
) =>
  startDate && position === 'end' ? date.isBefore(startDate) || date.isAfter(dayjs(startDate).add(1, 'year')) : false;

export const futureDate = (date: Dayjs) => date.isAfter(dayjs());
